<div class="boolean-div">
  @if (icon) {
    <mat-icon [ngClass]="colorClass">{{this.icon}}</mat-icon>
  } @else {
    <span class="unknown">?</span>
  }
</div>
